import { ulid } from 'ulid';

import { WsSalesSolutionAction, WsSalesSolutionMetric, WsSalesSolutionItem, WsSalesSolutionDependency, WsSalesSolutionAssumption, WsSalesProcess, WsSalesSolutionArea } from '../../../core';

import { apiGet, apiPost } from '../../../helpers-sales';




const areaData: { [ key: string ]: WsSalesSolutionArea }  = {
  '01H4GTG96RG0D54NABN15GTFTB': { id: '01H4GTG96RG0D54NABN15GTFTB', name: 'Core',             description: 'Enables the provisioning & management of user-customized Windows 11 devices through a secure, cloud-based solution anywhere. Enhances organizational visibility of endpoint devices & end-user experiences. Leverages Microsoft enterprise licensing entitlements to provide greater ROI.' },
  '01H4GTG96R72GBPXJS0AA0VQN4': { id: '01H4GTG96R72GBPXJS0AA0VQN4', name: 'Security',         description: 'The Security offering is a holistic, cloud-delivered endpoint security solution that focuses on enabling employees to be productive, while protecting company data. This is done using a zero-trust mindset to verify access explicitly.' },
  '01H4GTG96RDX8QTVHM3JE5JFTQ': { id: '01H4GTG96RDX8QTVHM3JE5JFTQ', name: 'Virtualization',   description: 'Enables secure, hybrid work through cloud-based desktop and app virtualization. It offers high-performance and low-latency solutions to employees everywhere. Leverages Microsoft enterprise licensing entitlements to provide greater ROI.' },
  '01H4GTG96RDZTAHKDXWN1JYM2F': { id: '01H4GTG96RDZTAHKDXWN1JYM2F', name: 'Manage & Envolve', description: 'Enables secure, hybrid work through cloud-based desktop and app virtualization. It offers high-performance and low-latency solutions to employees everywhere. Leverages Microsoft enterprise licensing entitlements to provide greater ROI.' }
};




export const getSalesAreas = () => {
  return areaData;
};




// export const getSalesSolutionItemsFromConfig = (configData: { offerings: any[], actions: any[], metrics: any[]}) => {

//   // const metrics = configData.metrics;

//   configData.offerings.forEach((offeringData) => {

//     const offering: WsSalesSolutionItem = {
//       id: offeringData.id,
//       name: offeringData.name,
//       areaId: offeringData.areaId
//     };

//     const offeringChildren = configData.offerings.filter((offeringChild) => offeringData.childIds.includes(offeringChild.id));

//     if (offeringChildren.length > 0) {
//       offering.items = offeringChildren;
//     }

//     const offeringActions = configData.actions.filter((offeringAction) => offeringData.actionIds.includes(offeringAction.id));

//     if (offeringActions.length > 0) {
//       offering.actions = offeringActions;
//     }

//   });

// };




const itemsData: WsSalesSolutionItem[] = [];




const getItemsCopy = (children: WsSalesSolutionItem[] | WsSalesSolutionAction[], type: string, mode?: string) => {

  children.forEach((child: any) => {

    child.id = ulid();

    if (type === 'action') {
      child.selected = true;
    }

    if (mode === 'admin') {
      if (child.items && Array.isArray(child.items) && child.items.length > 0) {
        child.expanded = true;
      }
    }

    if (child.items) {
      getItemsCopy(child.items, 'offering');
    }

    if (child.actions) {
      getItemsCopy(child.actions, 'action');
    }

    if (child.metrics) {
      getItemsCopy(child.metrics, 'metric');
    }
  });

  return children;
};




export const newItem = () => {
  const item: WsSalesSolutionItem = {
    id: ulid(),
    name: 'New Capability',
    description: '',
    sizeDescription: {
      S:  '',
      M:  '',
      C:  '',
      VC: ''
    },
    linkIds: []
  };

  return item;
};




export const newAction = () => {
  const item: WsSalesSolutionAction = {
    id:            ulid(),
    name:          'New Action',
    description:   '',
    dependencyIds: [],
    sequential:    true,
    parallel:      0
  };

  return item;
};




export const newMetric = () => {
  const item: WsSalesSolutionMetric = {
    id: ulid(),
    name: 'New Metric',
    value:  1,
    effort: 1,
    defaultEffort: 1,
    defaultValue:  1,
    core: false
  };

  return item;
};




export const newDependency = (name?: string) => {
  const item: WsSalesSolutionDependency = {
    id: ulid(),
    name: name ? name : ''
  };

  return item;
};




export const newAssumption = (name?: string) => {
  const item: WsSalesSolutionAssumption = {
    id: ulid(),
    name: name ? name : ''
  };

  return item;
};




const getSalesSolutionItemsFromConfig = async (data: any[], mode?: string) => {

  console.log('getSalesSolutionItemsFromConfig');

  const items = getItemsCopy(data, 'offering', mode);

  return items;
};




export const getSalesSolutionItems = async (mode?: string) => {

  const items = getItemsCopy(itemsData, 'offering', mode);

  return items;
};




export const getConfigValue = async (key: string, mode?: string) => {

  const config = await apiGet(`/sales/configuration/${key}`);

  if (config && config.configuration && config.configuration.value) {
    return config.configuration.value;
  } else {
    return undefined;
  }

  // if (config && config.configuration && config.configuration.value && config.configuration.value.items && Array.isArray(config.configuration.value.items) && config.configuration.value.items.length > 0) {

  //   const salesSolutionItems = await getSalesSolutionItemsFromConfig(config.configuration.value.items, 'admin');
  //   return salesSolutionItems;

  // } else {

  //   if (mode === 'admin') {
  //     const salesSolutionItems = await getSalesSolutionItems('admin');
  //     return salesSolutionItems;

  //   } else {
  //     return [];
  //   }
  // }
};




export const setConfigValue = async (key: string, value: any, mode?: string) => {

  const config = await apiPost(`/sales/configuration/${key}`, value);

  if (config && config.configuration && config.configuration.value) {
    return config.configuration.value;
  } else {
    return undefined;
  }
};




export const getSalesOfferingsFromSolution = async (mode?: string) => {
};




export const getSalesSolution = async (id: number | string, pass?: boolean): Promise<WsSalesProcess | undefined> => {

  const result = await apiGet(pass ? `/sales/solutions/${id}?pass=true` : `/sales/solutions/${id}`);

  if (result && result.salesSolution) {

    // const salesSolutionItems = await getSalesSolutionItemsFromConfig(config.configuration.value.items, 'admin');
    // return salesSolutionItems;

    return result.salesSolution;

  } else {

    // if (mode === 'admin') {
    //   const salesSolutionItems = await getSalesSolutionItems('admin');
    //   return salesSolutionItems;

    // } else {
    //   return [];
    // }

    return undefined;
  }
};
